export default {
  OwnRisk: 'OW',
  BasicInsurance: 'MB',
  ExtraAdditionalInsurance: 'XA',
  AdditionalInsurance: 'AP',
  DentalInsurance: 'TA',
};
